module.exports = __webpack_public_path__ + "img/list.37b2ffe7.svg";